/**
 * useInviteActions Hook
 *
 * Custom hook for invite management actions
 */

const useInviteActions = (getAccessTokenSilently, fetchInvites) => {
    const handleDeactivate = async (inviteKey) => {
        if (!window.confirm('Are you sure you want to deactivate this invite?')) {
            return;
        }

        try {
            const token = await getAccessTokenSilently();
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
            const response = await fetch(`${API_BASE_URL}/invites/${inviteKey}/deactivate`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to deactivate invite');
            }

            // Refresh invites
            await fetchInvites();
        } catch (err) {
            // Error deactivating invite
            alert('Failed to deactivate invite: ' + err.message);
        }
    };

    const handleRemoveAccess = async (inviteKey, userName) => {
        if (!window.confirm(`Are you sure you want to remove access for ${userName}?\n\nThis will:\n- Remove their access to the budget\n- End-date their user category\n- They can be re-invited later if needed`)) {
            return;
        }

        try {
            const token = await getAccessTokenSilently();
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
            const response = await fetch(`${API_BASE_URL}/invites/${inviteKey}/remove-access`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to remove access');
            }

            // Refresh invites
            await fetchInvites();
        } catch (err) {
            // Error removing access
            alert('Failed to remove access: ' + err.message);
        }
    };

    return { handleDeactivate, handleRemoveAccess };
};

export default useInviteActions;
